import React from "react"
import {getQuestionGroupV2, QUESTION_GROUPS, QUESTION_TYPE} from "../../../shared/utils/constants";
import TitleSectionComponent from "./TitleSectionComponent";
import {getQuestionProps, getSectionProps, popInitialSelectMenuItems} from "./helpers/BuilderContainerHelper";
import {Draggable} from "react-beautiful-dnd";
import QuestionContainer from "./QuestionContainer";
import {isMobile} from "react-device-detect";
import {useSelector} from "react-redux";
import Loader from "../../../shared/components/Loader";
import {BUILDER_PER_PAGE_LIMIT} from "../../../admin/constants";

const Questions = (props) => {
    const userId = useSelector(state => state.userReducer?.userId)
    const formData = useSelector(state => state.appReducer.formData)
    const isDragAndDropDisabled = useSelector(state => state.builderReducer.isDragAndDropDisabled)

    if (props.questions) {
        return (
            <div ref={props.refCardsContainer}
                 className="builder-cards-container">
                {
                    props.questions?.map((question, questionIndex) => (
                        () => {
                            const index = (props.selectedPage * BUILDER_PER_PAGE_LIMIT) + questionIndex
                            let questionGroup = getQuestionGroupV2(QUESTION_TYPE[question.type])

                            if (questionGroup === QUESTION_GROUPS.SECTION) {
                                return (<div
                                        style={{marginBottom: formData.pages[0].questions?.length - 1 === index ? "10vh" : null}}>
                                        {formData?.is_logic_enabled ?
                                            <div>
                                                <TitleSectionComponent {...getSectionProps(question, index)}/>
                                            </div> :
                                            <Draggable
                                                key={question._id}
                                                draggableId={question._id}
                                                index={index}
                                                isDragDisabled={isDragAndDropDisabled}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <TitleSectionComponent {...getSectionProps(question, index)}/>
                                                    </div>)}
                                            </Draggable>}
                                    </div>
                                )
                            } else {
                                let qnInfo = props.questionNumberInfo.filter(questionInfo => questionInfo.questionIndex === index)

                                popInitialSelectMenuItems(question.type)

                                return (
                                    <>
                                        {formData?.is_logic_enabled ?
                                            <div>
                                                <QuestionContainer
                                                    {...getQuestionProps(question, index, qnInfo, userId, isMobile)}
                                                    refSavedData={props.refSavedFormData}
                                                    formData={formData}/>
                                            </div> :
                                            <Draggable
                                                key={question._id}
                                                draggableId={question._id}
                                                index={index}
                                                isDragDisabled={isDragAndDropDisabled}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <QuestionContainer
                                                            {...getQuestionProps(question, index, qnInfo, userId, isMobile)}
                                                            refSavedData={props.refSavedFormData}
                                                            formData={formData}/>
                                                    </div>)}
                                            </Draggable>}
                                    </>
                                )
                            }
                        })()
                    )
                }
            </div>
        )
    } else {
        return <Loader/>
    }
}

export default Questions
